import React, { useState, useEffect } from 'react';
import NavigationDots from './NavigationDots';
import SocialMedia from './SocialMedia';
import { client } from '../client';

const AppWrap = (Component, idName, classNames) => function HOC() {
  const [nameData, setNameData] = useState(null);

  useEffect(() => {
    const nameQuery = '*[_type == "name"][0]';
    
    client.fetch(nameQuery).then((data) => {
      setNameData(data);
    }).catch(err => console.error('AppWrap Name fetch error:', err));
  }, []);

  return (
    <div id={idName} className={`app__container ${classNames}`}>
      <SocialMedia />
      <div className="app__wrapper app__flex">
        <Component />

        <div className="copyright">
          <p className="p-text">@2025 {nameData?.fullName?.toUpperCase() || nameData?.firstName?.toUpperCase() || 'SUNNY JONWAL'}</p>
          <p className="p-text">All rights reserved</p>
        </div>
      </div>
      <NavigationDots active={idName} />
    </div>
  );
};

export default AppWrap;
